<template>
    <v-tabs v-model="tab" show-arrows :class="`${!!errorsInTabs.find((x) => x == tab) ? 'v-tabs--error' : ''}`">
        <v-tab
            v-for="(item, index) in items"
            :key="item.text"
            :class="`${!!errorsInTabs.find((x) => x == index) ? 'v-tab--error' : ''}`"
        >
            <div class="tab">
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                <v-slide-x-transition>
                    <v-fade-transition>
                        <v-icon v-if="!!errorsInTabs.find((x) => x == index)" class="error-icon" left dense color="red"
                            >mdi-alert</v-icon
                        >
                    </v-fade-transition>
                </v-slide-x-transition>
                {{ item.text }}
            </div>
        </v-tab>
    </v-tabs>
</template>

<script>
export default {
    data() {
        return {
            tabsErrors: {
                0: [
                    'surname',
                    'forename',
                    'birth_date',
                    'gender',
                    'race',
                    'address',
                    'nhs_id',
                    'post_code',
                    'second_address',
                    'country',
                    'county',
                    'town',
                    'pharmacy_site_id',
                    'consultant_id',
                ],
                1: [
                    'cnrd_date',
                    'up_to_including_date',
                    'normal_blood_sample_day',
                    'tablet_qty25',
                    'tablet_qty50',
                    'status',
                    'tablet_qty100',
                    'tablet_qty200',
                    'is_registered',
                    'suspension_amount',
                    'is_checked',
                    'is_locked',
                    'is_with_ben',
                    'cnrd_entry_found',
                ],
                2: [
                    'diagnosis',
                    'is_prescribed_clozapine',
                    'is_with_sch',
                    'is_with_park',
                    'is_chemo_or_observation',
                    'is_under_monitoring',
                    'is_with_bone_disease',
                    'is_in_patient',
                    'previous_anti_psychotics',
                    'ward_name',
                ],
                3: [],
                4: [
                    'date_taken',
                    'blood_result_provider_id',
                    'date_received',
                    'sample_ref',
                    'platelets',
                    'neutrophils',
                    'white_blood_count',
                    'memo',
                    'notification_to',
                ],
            },
        };
    },
    computed: {
        errorsInTabs() {
            const errors = {
                ...this.$store.state.patients.errorMessages.patient,
                ...this.$store.state.patients.errorMessages.patient.health_information,
                ...this.$store.state.patients.errorMessages.patient.diagnosis,
                ...this.$store.state.patients.errorMessages.bloodResult,
            };
            const Errors = [];
            const errorsInTabs = [];
            Object.keys(errors).forEach((val) => {
                if (errors[val] && errors[val].length) {
                    Errors.push(val);
                }
            });
            Object.keys(this.tabsErrors).forEach((tab) => {
                Object.values(this.tabsErrors[tab]).forEach((error) => {
                    if (Errors.includes(error)) {
                        errorsInTabs.push(tab);
                    }
                });
            });
            return _.sortedUniq(errorsInTabs);
        },
        hasErrorInTab() {
            return this.$store.state.patients.errorsInTabs;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        items() {
            // const items = [
            //     { icon: 'icon icon-details-tab', text: t('patients::tabs.items.details'), active: true },
            //     { icon: 'icon icon-health-info-tab', text: t('patients::tabs.items.health_info'), active: true },
            //     { icon: 'icon icon-diagnosis-tab', text: t('patients::tabs.items.diagnosis'), active: true },
            //     {
            //         icon: 'icon icon-dispensing-stages-tab',
            //         text: t('patients::tabs.items.dispensing_stage'),
            //         active: false,
            //     },
            //     { icon: 'icon icon-blood-results-tab', text: t('patients::tabs.items.blood_results'), active: false },
            //     { icon: 'icon icon-memos-tab', text: t('patients::tabs.items.memos'), active: false },
            // ];
            const items = [
                { text: t('patients::tabs.items.details'), active: true },
                { text: t('patients::tabs.items.health_info'), active: true },
                { text: t('patients::tabs.items.diagnosis'), active: true },
                { text: t('patients::tabs.items.dispensing_stage'), active: false },
                { text: t('patients::tabs.items.blood_results'), active: false },
                { text: t('patients::tabs.items.memos'), active: false },
                { text: t('patients::tabs.items.adverse_event'), active: false },
            ];
            return items.filter((x) => (x.active ? true : this.patientId));
        },
        tab: {
            get() {
                return this.$store.state.patients.tab;
            },
            set(value) {
                if (this.tab === 4 && value !== this.tab) {
                    this.$store.dispatch('patients/loadBloodResult', { id: null });
                }
                this.$store.dispatch('patients/changeTab', value);
            },
        },
    },
};
</script>

<style></style>
